import { render, staticRenderFns } from "./bao-cao-cong-no.vue?vue&type=template&id=63821ecd&scoped=true&"
import script from "./bao-cao-cong-no.vue?vue&type=script&lang=js&"
export * from "./bao-cao-cong-no.vue?vue&type=script&lang=js&"
import style0 from "./bao-cao-cong-no.vue?vue&type=style&index=0&id=63821ecd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63821ecd",
  null
  
)

export default component.exports